import BooleanPlugins from "./boolean/PluginSetup.js";
import GeoPointPlugins from "./geoPoint/PluginSetup.js";
import NumericPlugins from "./numeric/PluginSetup.js";
import StringPlugins from "./string/PluginSetup.js";
import UnitPlugins from "./unit/PluginSetup.js";
import EnumPlugins from "./enum/PluginSetup.js";
import ResourceEnumPlugins from "./resourceEnum/PluginSetup.js";
import ParentRelationshipPlugins from "./parentRelationship/PluginSetup.js";
import SharedPlugins from "./shared/PluginSetup.js";
export default {
  install(molten) {
    BooleanPlugins.install(molten);
    GeoPointPlugins.install(molten);
    NumericPlugins.install(molten);
    StringPlugins.install(molten);
    UnitPlugins.install(molten);
    EnumPlugins.install(molten);
    ResourceEnumPlugins.install(molten);
    ParentRelationshipPlugins.install(molten);
    SharedPlugins.install(molten);
  }
};